import React from 'react';

export const Toaster: React.FC = () => {
  // Simple placeholder - in a real app, you'd implement a toast notification system
  return <div id="toaster" />;
};
